import { Grid, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { clientsApi, usersApi, usinasApi } from "../../../services/api";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import TextInput from "../../../main/components/TextInput";
import { ActionAlert } from "../../../main/components/alerts/ActionAlert";
import { useNavigate } from "react-router-dom";
import { MainContext } from "../../../main/context/MainContextProvider";
import Loading from "../../../main/components/Loading";
import SelectItemsTable from "../../../main/components/SelectItemsTable";
import { Item } from "../components/UserItemsTable";
import PrimaryBaseButton from "../../../main/components/PrimaryBaseButton";
import { emailRegex, phoneRegex, validateCPF } from "../../../main/utils/utils";
import CpfInput from "../../../main/components/CpfInput";
import PhoneNumberInput from "../../../main/components/PhoneNumberInput";
import SelectItemTable from "../../../main/components/SelectItemTable";

const schema = yup.object().shape({
  name: yup.string().required("Nome é obrigatório"),
  email: yup
    .string()
    .matches(emailRegex, "Formato de email inválido")
    .required("Email é obrigatório"),
  cpf: yup
    .string()
    .test("isCpfValid", "O CPF informado é inválido", (v) =>
      !!v ? validateCPF(v) : true
    ),
  phone: yup.string().matches(phoneRegex, "Formato de Telefone inválido"),
});
export type NewUserFormType = yup.InferType<typeof schema>;
export default function NewUser() {
  const { userIsAdm } = useContext(MainContext);
  const [showErrorModal, setShowErrorModal] = useState<boolean>(false);
  const [showSuccessModal, setShowSuccessModal] = useState<boolean>(false);
  const [loadingCreation, setLoadingCreation] = useState<boolean>(false);
  const [loadingMount, setLoadingMount] = useState<boolean>(false);
  const [loadingMountUsinas, setLoadingMountUsinas] = useState<boolean>(false);
  const [usinas, setUsinas] = useState<Item[]>([]);
  const [selectedUsinas, setSelectedUsinas] = useState<Item[]>([]);
  const [clients, setClients] = useState<Item[]>([]);
  const [selectedClient, setSelectedClient] = useState<Item>();
  const [roles, setRoles] = useState<Item[]>([]);
  const [selectedRoles, setSelectedRoles] = useState<Item[]>([]);
  // const [notifications, setNotifications] = useState<Item[]>([]);
  // const [selectedNotifications, setSelectedNotifications] = useState<Item[]>(
  //   []
  // );
  const navigate = useNavigate();
  const {
    control,
    formState: { errors },
    handleSubmit,
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onMount = async () => {
    setLoadingMount(true);
    try {
      if (userIsAdm) {
        const clientsResponse = await clientsApi.getClients();
        setClients(clientsResponse.data);
        const rolesResponse = await usersApi.getAllRoles();
        setRoles(rolesResponse);
        // const notifications = await notificationsApi.getNotifications();
        // setNotifications(notifications.data);
      } else {
        // TODO: implementar get de usuários
      }
    } catch (error) {
      throw new Error("Erro ao buscar dados para criação de usuário");
    } finally {
      setLoadingMount(false);
    }
  };
  useEffect(() => {
    onMount();
  }, []);

  useEffect(() => {
    if (selectedClient) updateClientUsinas(selectedClient.id ?? "");
  }, [selectedClient]);

  const updateClientUsinas = async (clientId: string) => {
    setLoadingMountUsinas(true);
    try {
      const response = await usinasApi.getUsinasByClientId(clientId);
      const usinasItems = response.data.map((usina) => {
        return { id: usina.usinaIds.id, name: usina.name };
      });
      setUsinas(usinasItems);
    } catch (error) {
      console.error(error);
      setUsinas([]);
    } finally {
      setLoadingMountUsinas(false);
    }
  };
  const onSubmit = async (data: NewUserFormType) => {
    if (!selectedClient) return;

    // Filtra valores indefinidos de usinasIds
    const usinasIds = selectedUsinas
      .map((usina) => usina.id)
      .filter((id): id is string => id !== undefined);
    const rolesValues = selectedRoles
      .map((role) => role.name)
      .filter((role): role is string => role !== undefined);

    const postData = {
      ...data,
      cpf: data.cpf ?? null,
      phone: data.phone ?? null,
      clients: [
        {
          clientId: selectedClient?.id ?? "",
          clientName: selectedClient?.name ?? "",
          roles: rolesValues,
          usinas: usinasIds,
        },
      ],
    };

    try {
      setLoadingCreation(true);
      await usersApi.postUser(postData);
      setShowSuccessModal(true);
    } catch (error) {
      setShowErrorModal(true);
    } finally {
      setLoadingCreation(false);
    }
  };

  // const onSubmit = async (data: NewUserFormType) => {
  //   if (!selectedClient) return;

  //   const usinasIds = selectedUsinas.map((usina) => usina.id);
  //   const rolesValues = selectedRoles
  //     .map((role) => role.name)
  //     .filter((role) => role !== undefined) as string[];
  //   // const notificationsIds = selectedNotifications.map( (notification) => notification.id);

  //   const { ...dataWithoutPasswordConfirmation } = data;
  //   const postData = {
  //     ...dataWithoutPasswordConfirmation,
  //     cpf: data.cpf ?? null,
  //     phone: data.phone ?? null,
  //     clients: [
  //       {
  //         clientId: selectedClient?.id ?? "",
  //         clientName: selectedClient?.name ?? "",
  //         roles: [...rolesValues],
  //         usinas: usinasIds,
  //       },
  //     ],
  //   };
  //   try {
  //     setLoadingCreation(true);
  //     await usersApi.postUser(postData);
  //     setShowSuccessModal(true);
  //   } catch (error) {
  //     setShowErrorModal(true);
  //   } finally {
  //     setLoadingCreation(false);
  //   }
  // };

  return (
    <Grid
      container
      component={"form"}
      spacing={2}
      onSubmit={handleSubmit(onSubmit)}
      width={"100%"}
      // maxWidth={"900px"}
      // justifyContent={"center"}
      padding={"20px"}
      marginBottom={"20px"}
      sx={{
        justifyContent: loadingMount ? "center" : "start",
        width: "100%",
        height: "100%",
      }}
    >
      {loadingMount ? (
        <>
          <Loading />
        </>
      ) : (
        <>
          <Grid item xs={12} style={{ textAlign: "left" }}>
            <Typography
              sx={{
                marginTop: "40px",
                marginBottom: "40px",
                marginRight: "10px",
                fontWeight: 500,
                fontSize: {
                  xs: "18px",
                  sm: "24px",
                },
              }}
            >
              {userIsAdm ? "Cadastrar Usuário" : "Crie sua conta"}
            </Typography>
          </Grid>
          <Grid item xs={12} textAlign={"start"}>
            <Typography
              variant="h6"
              sx={{
                borderBottom: "1px solid #ccc",
                paddingBottom: 1,
                marginBottom: "15px",
              }}
            >
              Dados
            </Typography>
          </Grid>
          <Grid display={"flex"} item xs={12} md={6}>
            <TextInput
              label={"Nome"}
              control={control}
              errors={errors}
              fieldName={"name"}
              sx={{
                width: "100%",
                // maxWidth: { xs: "300px", md: "250px" },
              }}
            />
          </Grid>
          <Grid display={"flex"} item xs={12} md={6}>
            <CpfInput
              label={"CPF"}
              control={control}
              errors={errors}
              fieldName={"cpf"}
              sx={{
                width: "100%",
                // maxWidth: { xs: "300px", md: "250px" },
              }}
            />
          </Grid>
          <Grid display={"flex"} item xs={12} md={6}>
            <TextInput
              disabled={!userIsAdm}
              label={"Email"}
              control={control}
              errors={errors}
              fieldName={"email"}
              sx={{
                width: "100%",
                // maxWidth: { xs: "300px", md: "250px" },
              }}
            />
          </Grid>
          <Grid display={"flex"} item xs={12} md={6}>
            <PhoneNumberInput
              label={"Telefone"}
              control={control}
              errors={errors}
              fieldName={"phone"}
              sx={{
                width: "100%",
                // maxWidth: { xs: "300px", md: "250px" },
              }}
            />
          </Grid>
          <Grid item xs={12} textAlign={"start"}>
            <Typography
              variant="h6"
              sx={{
                borderBottom: "1px solid #ccc",
                paddingBottom: 1,
                marginBottom: "15px",
                marginTop: "30px",
              }}
            >
              Clientes
            </Typography>
          </Grid>
          <Grid display={"flex"} item xs={12}>
            <SelectItemTable
              items={clients}
              selectedItem={selectedClient}
              setSelectedItem={setSelectedClient}
            />
          </Grid>
          <Grid item xs={12} textAlign={"start"}>
            <Typography
              variant="h6"
              sx={{
                borderBottom: "1px solid #ccc",
                paddingBottom: 1,
                marginBottom: "15px",
                marginTop: "30px",
              }}
            >
              Usinas
            </Typography>
          </Grid>
          <NewUserUsinas
            usinas={usinas}
            selectedUsinas={selectedUsinas}
            setSelectedUsinas={setSelectedUsinas}
            selectedClient={selectedClient}
            loadingMount={loadingMountUsinas}
          />

          {/* <Grid textAlign={"start"} item xs={12} sm={6}>
            <Typography
              sx={{
                fontWeight: 500,
                fontSize: "16px",
                marginBottom: "10px",
              }}
            >
              Clientes
            </Typography>
            <SelectItemsTable
              items={clients}
              selectedItems={selectedClients}
              setSelectedItems={setSelectedClients}
            />
          </Grid> */}
          <Grid item xs={12} textAlign={"start"}>
            <Typography
              variant="h6"
              sx={{
                borderBottom: "1px solid #ccc",
                paddingBottom: 1,
                marginBottom: "15px",
                marginTop: "30px",
              }}
            >
              Perfis
            </Typography>
          </Grid>
          <Grid display={"flex"} item xs={12}>
            <SelectItemsTable
              items={roles}
              selectedItems={selectedRoles}
              setSelectedItems={setSelectedRoles}
            />
          </Grid>

          {/* <Grid textAlign={"start"} item xs={12} sm={6}>
            <Typography
              sx={{
                fontWeight: 500,
                fontSize: "16px",
              }}
            >
              Notificações
            </Typography>
            <SelectItemsTable
              items={notifications}
              selectedItems={selectedNotifications}
              setSelectedItems={setSelectedNotifications}
            />
          </Grid> */}

          <Grid item xs={12} style={{ textAlign: "right" }}>
            <PrimaryBaseButton
              type="submit"
              title="Confirmar dados"
              loading={loadingCreation}
              sx={{ marginTop: "10px", marginBottom: "25px" }}
            />
          </Grid>
          <ActionAlert
            message="Usuário criado com sucesso, você será redirecionado para a tela de listagem de usuários"
            severity="success"
            open={showSuccessModal}
            setOpen={setShowSuccessModal}
            onClose={() => {
              navigate("/users");
            }}
          />
          <ActionAlert
            message="Ocorreu um erro ao criar o usuário, tente novamente"
            severity="error"
            open={showErrorModal}
            setOpen={setShowErrorModal}
          />
        </>
      )}
    </Grid>
  );
}

function NewUserUsinas(props: {
  usinas: Item[];
  selectedUsinas: Item[];
  setSelectedUsinas: (usinas: Item[]) => void;
  selectedClient: Item | undefined;
  loadingMount?: boolean;
}) {
  const {
    usinas,
    selectedUsinas,
    setSelectedUsinas,
    selectedClient,
    loadingMount,
  } = props;
  const showUsinas = selectedClient !== undefined && !loadingMount;
  return (
    <Grid display={"flex"} item xs={12}>
      {!selectedClient ? (
        <Typography
          sx={{
            paddingBottom: 1,
            justifyContent: "center",
            display: "flex",
            alignItems: "center",
            width: "100%",
          }}
        >
          Selecione um cliente para visualizar as usinas
        </Typography>
      ) : (
        <>
          {loadingMount && <Loading />}
          {showUsinas && (
            <SelectItemsTable
              items={usinas}
              selectedItems={selectedUsinas}
              setSelectedItems={setSelectedUsinas}
            />
          )}
        </>
      )}
    </Grid>
  );
}
